module.exports = __webpack_public_path__ + "img/leave-distribution.73f15359.webp";